import React from 'react';
import T from 'prop-types';
import { Loader } from '@acast/decibel';
import EpisodeItem from './episodes-list-item';
import ListItem from './list-item';

function List({
  children,
  className,
  pending,
  episodes,
  emptyMessage,
  onEpisodeClicked,
  createdColumnHeading,
}) {
  function createListItem(content) {
    return <ListItem name={content} />;
  }

  function getListPendingIndicator() {
    if (pending && episodes.length === 0) {
      return createListItem(<Loader width={8} />);
    }
    return null;
  }

  function getListEmptyIndicator() {
    if (!pending && episodes.length === 0) {
      return createListItem(emptyMessage);
    }
    return null;
  }

  return (
    <div className={`show-page__episodes-list ${className}`}>
      <div className="episodes-list__list-items">
        <ListItem className="header" name="Title" created={createdColumnHeading} status="Status" />
        {getListPendingIndicator()}
        {getListEmptyIndicator()}
        {episodes.map((episode, i) => (
          <EpisodeItem key={i} episode={episode} onClick={onEpisodeClicked} />
        ))}
      </div>

      {children}
    </div>
  );
}

List.propTypes = {
  className: T.string,
  pending: T.bool,
  episodes: T.array.isRequired,
  emptyMessage: T.string,
  onEpisodeClicked: T.func.isRequired,
  children: T.node,
  createdColumnHeading: T.string.isRequired,
};

List.defaultProps = {
  className: '',
  pending: false,
  emptyMessage: 'No items.',
};

export default List;
